<template>
    <div class="map-page">
        <div class="map-wrap">
            <!-- TOUR MAP -->
            <tourMap :key="topicsList.length"/>
            <!-- TOUR SIDEBAR -->
            <aside>
                <div class="sidebar scroll-list">
                    <div class="aside-wrap">
                        <!-- SIDEBAR HEADER -->
                        <router-view name="header"></router-view>
                        <!-- SIDEBAR BODY -->
                        <router-view name="body"></router-view>
                        <md-dialog :md-click-outside-to-close="false" :md-active.sync="exportRunning">
                            <div class="md-dialog-container" tabindex="-1">
                                <span data-v-ec680dbc="" class="md-dialog-title md-title">
                                    You have requested an export of  <b data-v-ec680dbc="">
                                    <span class="text-nowrap">{{ currentTour.name }}</span>
                                    </b>- we will notify you via email when it is ready.
                                </span>
                                <div data-v-ec680dbc="" class="md-dialog-content">
                                    <b data-v-ec680dbc="">Client Name :</b>
                                    {{ this.currentClientName }}
                                </div>
                                <div data-v-ec680dbc="" class="md-dialog-content">
                                    <b data-v-ec680dbc="">Tours Name :</b>
                                    <span class="text-nowrap">{{ currentTour.name }}</span>
                                </div>
                                <div data-v-ec680dbc="" class="md-dialog-actions full-btn">
                                    <button data-v-ec680dbc="" type="button" style="background-color: #00A8CA" @click="closeDialog_export()" class="md-button md-raised md-primary md-theme-default">
                                        <div class="md-ripple">
                                            <span class="md-button-content">Close</span> <!---->
                                        </div>
                                    </button>
                                </div>
                            </div>
                        </md-dialog>
                    </div>
                </div>
            </aside>
            <!-- SETTINGS VIEWS -->
            <div v-if="showTourSettings || showRouteSettings" class="tour-settings-wrap" v-bind:class="{'open-settings': showSettings}">
                <!-- TOUR SETTINGS -->
                <TourSettings v-if="showTourSettings"></TourSettings>
                <!-- ROUTE SETTINGS -->
                <RouteSettings v-else-if="showRouteSettings"></RouteSettings>
                <!-- LIST OF STORY FILES -->
            </div>
            <TriggerStoryList class="story-media-list" v-bind:class="{'open-media-settings': showSettings}" v-else></TriggerStoryList>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import GoogleMaps from './GoogleMaps.vue';
import {mapState, mapGetters, mapActions} from 'vuex';
import TourSettings from './TourSettings.vue';
import RouteSettings from './RouteSettings.vue';
import TriggerStoryList from './TriggerStoryList.vue';

export default {
  components: {
    tourMap: GoogleMaps,
    TourSettings: TourSettings,
    RouteSettings: RouteSettings,
    TriggerStoryList: TriggerStoryList
  },
  computed: {
    ...mapState({routerPathName: state => state.RouterModule.name}),
    ...mapGetters('editor', ['showSettings']),
    ...mapGetters('tours', ['currentTour', 'exportRunning']),
    ...mapGetters('client', ['currentClient', 'currentClientName']),
    ...mapGetters('topics', ['currentTopic', 'topicsList']),
    showTourSettings () {
      return this.routerPathName === 'TopicsTab' || this.routerPathName === 'RoutesTab';
    },
    showRouteSettings () {
      return this.routerPathName === 'Route';
    }
  },
  methods: {
    ...mapActions('editor', ['toggleShowSettings']),
    ...mapActions('tours', ['closeExportModal']),
    ...mapActions('library', ['loadTourNotifications']),
    ...mapGetters('topics', ['currentTopic', 'topicsList']),
    closeDialog_export () {
      this.closeExportModal();
    }
  },
  beforeMount () {
    this.loadTourNotifications({tourId: this.currentTour.id, clientId: this.currentClient.id});
    const EventBus = new Vue();
    Object.defineProperties(Vue.prototype, {
      $bus: {
        get: function () {
          return EventBus;
        }
      }
    });
  }
};
</script>
<style lang="scss">
aside {
    width: 344px !important;
}

.aside-wrap {
    height: 100vh;
    width: 100% !important;
}

.map-page figure.tourFigure .md-icon {
    color: white !important;
}

figure .md-menu-content-container {
    top: 8px !important;
    left: 152px !important;
    transform-origin: right top 0px !important;
}

.close-new-tour {
    z-index: 4;
}

.upload-text {
    position: initial !important;
}

.photo-icon {
    height: 64px !important;
    width: 64px !important;
    line-height: 64px !important;
    // font-size: 32px !important;
    color: #00a8ca !important;
}

.newTourFigure .gradient-box {
    background-image: initial !important;
    background-color: rgb(250, 250, 250) !important;
}

.sidebar.scroll-list {
    min-height: 500px;
    height: 100vh;
}

.exportRunningModal {
    height: 80px;
}

.md-overlay {
    z-index: 51 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/tour/TourEditor.vue